module.exports = __webpack_public_path__ + "img/client-2.a231df67.png";